import { loadStripe } from '@stripe/stripe-js';

export default loadStripe;
